import { css } from '@emotion/css';

interface Props {
    timerCount: string;
    finishTimerCount: string;
    showCountBet: boolean;
}

export default function TimerMiniBC(props: Props) {
    const { timerCount, finishTimerCount, showCountBet } = props;
    return (
        <div className={styles.timerWrap}>
            <img className="table-img" src={require(`assets/images/mini-bc/timer.png`)} />

            <div className="count-time">
                {showCountBet ? (
                    <span className="count-timer text-white-gradient">{timerCount}</span>
                ) : (
                    <span className="count-timer timeLast">{finishTimerCount}</span>
                )}
            </div>
        </div>
    );
}

const styles = {
    timerWrap: css`
        position: relative;
        flex: 0 0 55px;
        width: 55px;
        .count-time {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: 500;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            span {
                font-weight: 700;
            }
            .timeLast {
                color: #11ff00;
            }
        }
    `,
};
